<template>
  <ModalWithBackdrop
    :title="currTitle"
    :label="confirmLabel"
    :busy="loading"
    v-bind="{ ...$attrs }"
    className="newMedicalMeeting"
    @secondaryaction="resetHard"
    @action="resolveConfirm"
    @closeclick="resetHard"
  >
    <div class="content__wrapper">
      <div class="content">
        <div class="searchInput">
          <input
            v-model="patientName"
            type="text"
            class="input-name"
            placeholder="Nome do paciente"
            :disabled="meetingId"
            @keyup="inputNamekeyUpHandler"
            @keydown="inputNameKeyDownHandler"
          />
          <img class="search-icon" src="@/assets/search_icon.png" />
          <template v-if="patientsSearched.length">
            <div
              class="suggestions-backdrop"
              @click="clearPatientSearchFilters"
            />
            <div class="suggestions-dropdown">
              <PatientSuggestion
                v-for="({ id, nome }, index) in patientsSearched"
                :key="index"
                :patientName="nome"
                @click.native="handleNamePick([nome, id])"
              />
            </div>
          </template>
        </div>
        <p class="interaction">Tipo de consulta</p>
        <div class="toggle-btns-box">
          <button
            :class="['toggle-btn', { off: !online }]"
            @click="toggleOnline"
          >
            Online
          </button>
          <button
            :class="['toggle-btn', { off: online }]"
            @click="toggleOnline"
          >
            Presencial
          </button>
        </div>
        <p class="interaction">Pra quando deseja marcar?</p>
        <div class="toggle-btns-box">
          <button
            :class="['toggle-btn', { off: !now }]"
            @click="togglemeetingNow"
          >
            Agora
          </button>
          <button
            :class="['toggle-btn', { off: now }]"
            @click="togglemeetingNow"
          >
            Futuro
          </button>
        </div>
      </div>
      <div :class="['datepicker', { off: now }]">
        <Datepicker
          ref="myDatepicker"
          :language="ptBR"
          inline
          :highlighted="highlighted"
          @selected="selectDate"
        />
        <template v-if="daySelected">
          <div
            :class="['input-name hours', { off: !selectedTime }]"
            @click="handleInputClick"
          >
            {{ selectedTime || 'Horários' }}
          </div>

          <div v-if="toggleTimeSuggestions" class="toggle-times">
            <div class="toggle-menu">
              <p v-if="!availableTimes.length" class="time-warning">
                Não há horários disponíveis para este dia.
              </p>
              <TimeSuggestion
                v-for="(time, index) in availableTimes"
                :key="index"
                :time="time"
                @click.native="handleTimePick(time)"
              />
            </div>
          </div>
          <p class="time-label">*Horários disponíveis</p>
        </template>
      </div>
    </div>
  </ModalWithBackdrop>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/dist/locale';
import { mapGetters, mapState, mapActions } from 'vuex';
import PatientSuggestion from './PatientSuggestion';
import TimeSuggestion from './TimeSuggestion';
import moment from 'moment';
import wait from '@/utils/wait';
import ModalWithBackdrop from '@/components/ModalWithBackdrop';

export default {
  name: 'NewMedicalMeeting',

  components: {
    Datepicker,
    PatientSuggestion,
    TimeSuggestion,
    ModalWithBackdrop,
  },

  data: () => ({
    ptBR: ptBR,
    online: true,
    now: true,
    typingTimer: null,
    typingInteval: 400,
    selectedTime: null,
    meetingId: null,
    daySelected: null,
    loading: false,
    patientSelected: null,
    toggleTimeSuggestions: false,
    patientName: null,
    highlighted: {
      dates: [new Date()],
    },
  }),

  computed: {
    ...mapGetters('dashboard', ['currWorkspace']),
    ...mapState('dashboard', ['showModals', 'patientsSearched']),
    ...mapState('dashboard/calendar', ['availableTimes']),
    ...mapState('meeting', ['currentAppointment']),

    currentHandler: function () {
      return this.meetingId
        ? obj => this.rescheduleMeeting([obj, this.meetingId])
        : this.createMeeting;
    },

    currTitle() {
      return this.meetingId ? 'Reagendar' : 'Marcar Consulta';
    },

    confirmLabel() {
      return this.loading ? 'Confirmando' : 'Confirmar';
    },
  },

  watch: {
    availableTimes() {
      this.toggleTimeSuggestions = true;
    },

    currentAppointment(appointment) {
      if (!appointment) return false;

      if (appointment.patientName !== this.patientName) {
        this.patientName = appointment.patientName;
        this.meetingId = appointment.id;
        this.patientSelected = [appointment.patientName, 0];
      }
    },
  },

  methods: {
    ...mapActions('dashboard', [
      'closeModals',
      'searchPatientByName',
      'clearPatientSearchFilters',
    ]),
    ...mapActions('meeting', ['createMeeting', 'rescheduleMeeting']),
    ...mapActions('dashboard/calendar', ['fetchAvailableTimes']),

    toggleOnline() {
      this.online = !this.online;
    },

    togglemeetingNow() {
      this.now = !this.now;
    },

    selectDate(date) {
      this.daySelected = moment(date);

      if (!this.daySelected.isValid()) return false;

      this.fetchAvailableTimes(this.daySelected);
    },

    async resetHard() {
      this.loading = false;
      this.closeModals();

      await wait(400);

      this.$refs.myDatepicker.clearDate();
      Object.assign(this, {
        online: true,
        now: true,
        toggleTimeSuggestions: false,
        patientSelected: null,
        daySelected: null,
        meetingId: null,
        patientName: null,
        selectedTime: null,
      });
    },

    resolveConfirm() {
      this.loading = true;

      const {
        patientSelected,
        currWorkspace,
        online,
        now,
        daySelected,
        selectedTime,
      } = this;

      if (!patientSelected) {
        this.loading = false;
        return alert('Selecione um paciente para continuar.');
      }

      if (!daySelected && !now) {
        this.loading = false;
        return alert('Selecione uma data para continuar.');
      }

      const [, patientId] = patientSelected;

      const newMeetingObj = {
        formaConsulta: online ? 'ONLINE' : 'PRESENCIAL',
        modoAtendimento: now ? 'IMEDIATO' : 'AGENDADO',
      };

      if (!this.meetingId) {
        Object.assign(newMeetingObj, {
          idPaciente: patientId,
          idClinica: currWorkspace.clinic.id,
        });
      }

      if (this.now) {
        return this.confirmNow(newMeetingObj);
      }

      Object.assign(newMeetingObj, {
        dataHora: `${daySelected.format('DD/MM/YYYY')} ${selectedTime}`,
      });

      return this.confirmScheduled(newMeetingObj);
    },

    confirmNow: async function (newMeeting) {
      try {
        const response = await this.currentHandler(newMeeting);
        const { $router } = this;
        if (this.meetingId) {
          return $router.push(`/treatments/${this.meetingId}`);
        }

        const { createdId } = response.data.object;
        $router.push(`/treatments/${createdId}`);
      } catch (err) {
        this.loading = false;
      }
    },

    confirmScheduled: async function (newMeeting) {
      try {
        await this.currentHandler(newMeeting);
        this.resetHard();
      } catch (err) {
        this.loading = false;
      }
    },

    inputNamekeyUpHandler(e) {
      clearTimeout(this.typingTimer);
      if (this.patientName?.length > 2) {
        this.typingTimer = setTimeout(() => {
          this.searchPatientByName(this.patientName);
        }, this.typingInteval);
      }
    },

    inputNameKeyDownHandler(e) {
      clearTimeout(this.typingTimer);
    },

    handleInputClick() {
      this.toggleTimeSuggestions = true;
    },

    handleNamePick([name, Id]) {
      this.patientSelected = [name, Id];
      this.patientName = name;
      this.clearPatientSearchFilters();
    },

    handleTimePick(time) {
      this.selectedTime = time;
      this.toggleTimeSuggestions = false;
    },
  },
};
</script>

<style lang="scss">
@import './unscopedStyle.scss';
</style>
<style lang="scss" scoped>
@import './style.scss';
</style>
